import type { MomentumUser } from '../../../shared/models/momentum-user.models';
import type {
  AssetTypeApi,
  ConfidentialityLevelApi,
  ProjectPickerItemDto,
} from './asset-api.models';

/** Draft version metadata + AI-only insight fields (not on PUT until backend adds them). */
export interface AssetReviewFormValue {
  title: string;
  description: string;
  type: AssetTypeApi;
  industries: string[];
  practices: string[];
  tags: string[];
  owner: MomentumUser | null;
  confidentiality: ConfidentialityLevelApi;
  reviewDate: string;
  language: string;
  relatedCapability: string;
  /** Reference assets — Insight project (C-number) linked to this version. */
  linkedProject: ProjectPickerItemDto | null;
}

export function defaultAssetReviewDate(): string {
  const date = new Date();
  date.setFullYear(date.getFullYear() + 1);
  return date.toISOString().slice(0, 10);
}

export function resolveAssetReviewDate(reviewDate: string): string {
  return reviewDate.trim() ? reviewDate.trim() : defaultAssetReviewDate();
}

export function emptyAssetReviewForm(): AssetReviewFormValue {
  return {
    title: '',
    description: '',
    type: 'Other',
    industries: [],
    practices: [],
    tags: [],
    owner: null,
    confidentiality: 'Internal',
    reviewDate: defaultAssetReviewDate(),
    language: '',
    relatedCapability: '',
    linkedProject: null,
  };
}
